import { WidgetProps } from '@rjsf/utils';
import React from 'react';
import { MANDATORY_FIELD_IDENTIFIER } from 'src/react-jsonschema-katal/katal/constants/ApplicationConstants';
import TextArea from 'src/components/TextArea';
import styled from 'styled-components';
import { KatTextarea } from '@amzn/katal-react';
import { TextViewWidget } from '../components/ViewWidget';

const TextAreaItem = styled.div``;

const TextAreaWidget: React.FC<WidgetProps> = ({
  value,
  onChange,
  disabled,
  label,
  required,
  rawErrors,
}) => {
  if (disabled) {
    return <TextViewWidget label={label} value={value} />;
  }

  if (required) {
    label = `${label}${MANDATORY_FIELD_IDENTIFIER}`;
  }
  const additionalErrorProps: KatTextarea._OwnProps = {};
  if (rawErrors && rawErrors.length > 0) {
    additionalErrorProps.state = 'error';
    additionalErrorProps.stateLabel = rawErrors
      .filter((error, index) => rawErrors.indexOf(error) === index)
      .join(',');
  }
  return (
    <TextAreaItem>
      <TextArea
        label={label}
        onTextAdded={onChange}
        value={value}
        disabled={disabled}
        {...additionalErrorProps}
      />
    </TextAreaItem>
  );
};

export default TextAreaWidget;
